import React, { Component } from 'react'
import gql from 'graphql-tag'
import { graphql } from '@apollo/client/react/hoc'
import { Col, Row } from 'reactstrap'
import MassMessageModal from '../../Material/MassMessageModal'
import AddNewDriver from './AddNewDriver'
import WeeklyChargeModal from '../../Material/WeeklyChargeModal'
import RepAssignmentModal from "../../Material/RepAssignmentModal"
import { HasPermissionsQuery } from "../../Functions/querys"
import ConfirmationPopup from "../../Material/ConfirmationPopup"
import TablePreferencePicker from "../../Material/TablePreferencePicker"
import ActionsPopup from "./ActionsPopup"
import './DriversListContainer.css'
import withApolloClient from '../../withApolloClient'

const UpdateDriver = gql`
    mutation updateDriverMutation($input: UpdateDriverMutationInput!){
    updateDriver(input:$input){
        ok
    }
} `

const DownloadDriverListMutation = gql`
    mutation downloadDriverList($input: DownloadDriverListInput!) {
        downloadDriverList(input: $input) {
            ok
            errors {
                messages
            }
        }
    }
`

const RemoveDriverAssignmentMutation = gql`
    mutation RemoveDriverAssignment($input: RemoveDriverAssignmentInput!) {
        removeDriverAssignment(input: $input) {
            ok
            errors {
                messages
            }
        }
    }
`

class DriverActions extends Component {
    constructor(props) {
        super(props)
        this.state = {
            openModal: "",
            configurations: null,
            driverListDownloaded: false,
            loading: false,
        }
    }
    toggleModal = (modalName) => {
        this.setState({ openModal: this.state.openModal === modalName ? "" : modalName })
    }
    unAssignDrivers = (assignmentCategory) => {
        this.setState({ loading: true })
        let input = {
            drivers: this.props.selectedDrivers,
            assignmentCategory: assignmentCategory
        }
        this.props.apolloClient.mutate({
            mutation: RemoveDriverAssignmentMutation,
            variables: { input },
        }).then((result) => {
            this.toggleModal("")
            this.setState({ loading: false })
            this.props.refetchQuery()
        })
    };
    updateDriver = (id, newvals) => {
        let input = {
            id: id,
            ...newvals
        }
        this.props.update(input).then(result => { this.props.refetchQuery() })
    }
    toggleHideDrivers = (action) => {
        let selectedDrivers = this.props.selectedDrivers
        selectedDrivers.map(item => {
            this.updateDriver(item, { hideFromCollections: action })
        })
        this.props.resetSelectedDrivers()
    }

    updateAutoCharge = () => {
        let selectedDrivers = this.props.selectedDrivers
        selectedDrivers.map(item => {
            this.updateDriver(item, { autoCharge: this.state.autoCharge })
        })
        this.props.resetSelectedDrivers()
        this.toggleModal("")
    }

    downloadDriverList = () => {
        this.setState({ loading: true, error: null, driverListDownloaded: false })
        let input = {
            filterValues: this.props.filterValues,
            selectedDrivers: this.props.selectedDrivers && this.props.selectedDrivers.length > 0 ? this.props.selectedDrivers : null,
            config: this.props.columnConfig || []
        }

        this.props.apolloClient.mutate({
            mutation: DownloadDriverListMutation,
            variables: { input }
        }).then(result => {
            const error = result.data?.downloadDriverList?.errors?.length > 0 ? result.data?.downloadDriverList?.errors[0].messages[0] : ""
            this.setState({ loading: false, error: error, driverListDownloaded: !error })
        }).catch(error => {
            this.setState({ loading: false, error: error.toString() })
        }).finally(() => {
            setTimeout(() => {
                this.setState({ error: "" })
            }, 5000)
        })
    }

    render() {
        return (
            <Row>
                <Col xs={12} className="text-right mt-3">
                    {this.props.activeTab !== "Schedules" &&
                        <>
                            <a id="toggleColumnPickerButton" className="driver-list-button" onClick={() => this.toggleModal("viewColumnPicker")}>
                                PREFERENCE | <i className="fa fa-table" aria-hidden="true"></i>
                            </a>&nbsp;&nbsp;&nbsp;&nbsp;
                        </>
                    }
                    {this.state.openModal === "MassMessageModal" && <MassMessageModal handleClose={() => this.toggleModal("MassMessageModal")} open={this.state.openModal === "MassMessageModal"} drivers={this.props.selectedDrivers && this.props.selectedDrivers.length > 0 ? this.props.selectedDrivers : null} />}
                    {this.state.openModal === "AddNewDriver" && <AddNewDriver handleClose={() => this.toggleModal("AddNewDriver")} open={this.state.openModal === "AddNewDriver"} />}
                    {this.state.openModal === "WeeklyChargeModal" &&
                        <WeeklyChargeModal
                            open={this.state.openModal === "WeeklyChargeModal"}
                            handleClose={() => this.toggleModal(false)}
                            currentUser={this.props.currentUser}
                            selectedDrivers={this.props.selectedDrivers}
                        />
                    }
                    {this.state.openModal === "RepAssignmentModal" && <RepAssignmentModal
                        open={this.state.openModal === "RepAssignmentModal"}
                        title={"Assign " + this.props.selectedDrivers.length + " Selected Drivers to Reps"}
                        drivers={this.props.selectedDrivers}
                        handleClose={() => this.toggleModal(false)}
                        refetchDrivers={this.props.refetchQuery}
                        group={this.props.activeTab === "Collections" ? "Collectors" : "Sales Team"}
                        assignmentCategory={this.props.activeTab === "Collections" ? ["COLLECTOR", "SECONDARY_COLLECTOR"] : ["GENERAL"]}
                    />}
                    {this.state.openModal === "autoChargeConfirmation" &&
                        <ConfirmationPopup
                            open={this.state.openModal === "autoChargeConfirmation"}
                            message={"Are you sure you want to turn " + (this.state.autoCharge ? "on" : "off") + " auto charge for " + this.props.selectedDrivers.length + " selected drivers?"}
                            loading={this.state.loading}
                            handleClose={() => this.toggleModal("")}
                            action={"Yes"}
                            confirmAction={this.updateAutoCharge}
                            color="danger"
                            error={this.state.error ? this.state.error : ""}
                            success={this.state.insuranceCreated ? "Action Performed Successfully" : ""}
                        />
                    }
                    {this.state.openModal === "DownloadList" && this.props.totalDriverCount > 0 &&
                        <ConfirmationPopup
                            open={this.state.openModal === "DownloadList"}
                            message={!this.state.driverListDownloaded && "Are you sure you want to download the list of " + (this.props.selectedDrivers?.length || this.props.totalDriverCount || 0) + " drivers to your email?"}
                            loading={this.state.loading}
                            handleClose={() => { this.setState({ error: "" }); this.toggleModal("") }}
                            action={"Send List to my email"}
                            confirmAction={this.downloadDriverList}
                            color="primary"
                            error={this.state.error ? this.state.error : ""}
                            success={this.state.driverListDownloaded && "List sent to your email."}
                        />
                    }
                    {this.state.openModal === "viewActions" && <ActionsPopup
                        handleClose={() => this.toggleModal("")}
                        openModal={this.state.openModal}
                        activeTab={this.props.activeTab}
                        selectedDrivers={this.props.selectedDrivers}
                        filterValues={this.props.filterValues}
                        hasPermissions={this.props.hasPermissions}
                        toggleHideDrivers={this.toggleHideDrivers}
                        unAssignDrivers={this.unAssignDrivers}
                        handleUpdateAutoCharge={(modalName, value) => this.setState({ openModal: modalName, autoCharge: value })}
                        toggleModal={this.toggleModal}
                    />}
                    {this.state.openModal === "unAssignReps" && this.props.selectedDrivers.length > 0 &&
                        <ConfirmationPopup
                            open={this.state.openModal === "unAssignReps"}
                            message={"Are you sure you want to un-assign " + (this.props.selectedDrivers?.length) + (this.props.activeTab === "Collections" ? " collectors?" : " reps?")}
                            loading={this.state.loading}
                            handleClose={() => { this.setState({ error: "" }); this.toggleModal("") }}
                            action={"Un-assign"}
                            confirmAction={() => this.unAssignDrivers(this.props.activeTab === "Collections" ? "COLLECTOR" : "GENERAL")}
                            color="primary"
                            error={this.state.error ? this.state.error : ""}
                        />
                    }
                    {this.state.openModal === "unAssignSecondaryCollectors" && this.props.selectedDrivers.length > 0 &&
                        <ConfirmationPopup
                            open={this.state.openModal === "unAssignSecondaryCollectors"}
                            message={"Are you sure you want to un-assign " + (this.props.selectedDrivers?.length) + " secondary collectors?"}
                            loading={this.state.loading}
                            handleClose={() => { this.setState({ error: "" }); this.toggleModal("") }}
                            action={"Un-assign"}
                            confirmAction={() => this.unAssignDrivers("SECONDARY_COLLECTOR")}
                            color="primary"
                            error={this.state.error ? this.state.error : ""}
                        />
                    }
                    <a id="viewActions" className="driver-list-button" onClick={() => this.toggleModal("viewActions")}>
                        ACTIONS | <i className="fa fa-cog" aria-hidden="true"></i>
                    </a>&nbsp;&nbsp;&nbsp;&nbsp;
                    {this.state.openModal === "viewColumnPicker" &&
                        <TablePreferencePicker columnConfig={this.props.columnConfig} currentUser={this.props.currentUser} open={this.state.openModal === "viewColumnPicker"} target="toggleColumnPickerButton" setColumns={this.props.setColumns} refetchPreferences={this.props.refetchPreferences} preferenceType={this.props.preferenceType} />
                    }
                </Col>
                {this.props.selectedDrivers && this.props.selectedDrivers.length > 0 && <Col xs={12} className="mt-2 text-right">
                    {this.props.selectedDrivers && this.props.selectedDrivers.length > 0 && <><span className="search-filter-preview">
                        <span><i className="fa fa-times-circle" onClick={this.props.resetSelectedDrivers}></i> &nbsp;&nbsp; Selected Drivers</span>
                        {this.props.selectedDrivers.length === this.props.driverCountOnPage ? `All ${this.props.driverCountOnPage} on this page` : this.props.selectedDrivers.length}
                    </span>
                        {this.props.totalDriverCount > this.props.selectedDrivers.length && this.props.selectedDrivers.length === this.props.driverCountOnPage && <>&nbsp;&nbsp;<a className="driver-list-button">Select all {this.props.totalDriverCount} drivers in this list </a></>}
                    </>}
                </Col>}
            </Row>
        )
    }
}


//-----------------------------------
export default graphql(UpdateDriver, {
    props: ({ mutate }) => ({
        update: (input) => mutate({ variables: { input } }),
    }),
})(
    graphql(HasPermissionsQuery, {
        options: () => ({
            variables: {
                userPermissions: [
                    "custom_can_auto_charge",
                    "custom_can_unhide_collection",
                    "custom_can_hide_collection",
                    "add_driverassignment",
                    "custom_can_download_driver_list",
                ],
            },
        }),
        props: ({ data: { hasPermissions, loading, variables } }) => ({
            hasPermissions,
            loading,
            variables,
        }),
    })(withApolloClient(DriverActions))
)
